import { NotificationService } from './../../../services/notification.service';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment-timezone';
import { TranslateModule } from '@ngx-translate/core';
import { IncomingAlertCardComponent } from './incoming-alert-card/incoming-alert-card.component';
import { NgStyle } from '@angular/common';
import { CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { NotificationBadgeComponent } from 'app/components/notifications/notification-badge/notification-badge.component';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { ControlRoomService } from 'app/services/control-room.service';
import { AngularMaterialModules } from "app/angular-material-modules";
import { CrAlert } from 'app/services/crsync.service';

@Component({
    selector: 'control-room-alert-panel-incoming',
    templateUrl: './control-room-alert-panel-incoming.component.html',
    styleUrls: ['./control-room-alert-panel-incoming.css'],
    providers: [NotificationService],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatTabsModule, CdkDropList, CdkDrag, IncomingAlertCardComponent, TranslateModule, NotificationBadgeComponent, AngularMaterialModules, NgStyle]
})
export class ControlRoomAlertPanelIncomingComponent implements OnInit, OnDestroy {

  constructor(
    private notification: NotificationService,
    public crService: ControlRoomService,
  ) {
    const subscription1 = this.subscribeToAlertNotifications();
    const subscription2 = this.subscribeToExpiringVisitsNotification();

    if (subscription1) this.subscriptions.push(subscription1);
    if (subscription2) this.subscriptions.push(subscription2);
  }

  nightowlVisitAlert: CrAlert[] = [];

  get alerts(){
    const allAlerts = this.crService.incomingAlerts;
    this.nightowlVisitAlert = allAlerts.filter(alert => this.crService.alertIsNightowlVisit(alert));
    const filteredAlerts = allAlerts.filter(alert => !this.crService.alertIsNightowlVisit(alert));
    return filteredAlerts;
  }
  get visits(){
    return this.crService.incomingVisits
  }
  showTeamMembers: boolean = false;

  alertWarningStatus$ = new BehaviorSubject<boolean>(false);
  visitWarningStatus: boolean = false;
  notifyVisits$ = new Subject<any[]>();

  subscriptions: Subscription[] = [];

  ngOnInit() {
    setTimeout(() => this.updateElapsedTime(), 1000);
    this.updateRemainingVisitTime();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  subscribeToAlertNotifications(): Subscription {
    // Emits only when the value changes from 'false' to 'true'
    const submitAlertNotification$ = this.alertWarningStatus$.pipe(
      distinctUntilChanged(),
      filter((value) => value === true),
    );
    return submitAlertNotification$.subscribe(_ => this.notification.notifyUnansweredAlert());
  }

  subscribeToExpiringVisitsNotification(): Subscription {
    return this.notifyVisits$.subscribe(visits => {
      if (visits.length > 0) {
        this.notification.notifyRemainingTimeForVisits(visits.length);
        visits.forEach(visit => visit.notified = true);
      }
    })
  }

  calculateRemainingTime(data: any) {
    if (!this.crService.alertIsNightowlVisit(data)) {
        const timeRemaining = moment(data.end).diff(moment(), 'seconds');
        return timeRemaining;
      };
  
      const endTime = moment(data.cameraVisitStartTime).add(data.cameraVisitDurationMinutes, 'minutes');
      const timeLeft = endTime.diff(new Date(), 'seconds');
      return timeLeft;
  }

  countVisits() {
    return this.visits.length + this.nightowlVisitAlert.length;
  }

  alertStartTime(alarmTimeObj: any) {
    return alarmTimeObj["_i"];
  }

  updateRemainingVisitTime() {
    const visitsToNotify: any[] = [];
    let warningStatus = false;

    this.visits.forEach((v: any) => {
      v.timeRemaining = moment(v.end).diff(moment(), 'seconds');
      if (v.timeRemaining < 60 * 5 && !v.notified) visitsToNotify.push(v);
      if (v.notified || visitsToNotify.length > 0) warningStatus = true;
    });
    this.notifyVisits$.next(visitsToNotify);
    this.visitWarningStatus = warningStatus;

    setTimeout(() => this.updateRemainingVisitTime(), 1000);
  }

  updateElapsedTime() {
    let warningThresholdExceeded = false;

    this.alerts.forEach((alert: CrAlert) => {
      alert.showTime = new Date().getTime() - new Date(this.alertStartTime(alert.time)).getTime();
      alert.styleOutOfTime = alert.showTime / 1000 > 30 ? true : false;
      alert.styleBadlyOutOfTime = alert.showTime / 1000 > 120 ? true : false;
      if (alert.styleBadlyOutOfTime) warningThresholdExceeded = true;
    });
    this.alertWarningStatus$.next(warningThresholdExceeded);

    setTimeout(() => this.updateElapsedTime(), 1000);
  }

}
